<template>
  <div>
    <cx-dialog v-if='showForm'
               :visible="showForm"
               :title='title'
               :rules='rules'
               :model='form'
               width="500px"
               @ok='save'
               @close='showForm = false'>
      <el-row>
        <el-col :span="24">
          <el-form-item label="上级部门" prop='deptIdsArray'>
            <cx-cascader v-model="form.deptIdsArray" :options="deptList" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="部门名称" prop='name'>
            <cx-input v-model='form.name' />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
      </el-row>
    </cx-dialog>

    <cx-btn-group>
      <el-button type="success" icon="el-icon-refresh" size='mini' :loading="loading"
                 v-if="Util.havePermissions('/client-dept/list')" @click='query'>刷新</el-button>
      <el-button type="primary" icon="el-icon-plus" size='mini'
                 v-if="Util.havePermissions('/client-dept/add')" @click='add'>新增</el-button>
      <el-button type="warning" icon="el-icon-edit" size='mini'
                 v-if="Util.havePermissions('/client-dept/modify')" @click='edit'>修改</el-button>
    </cx-btn-group>

    <div class='tree'>
      <cx-input class='tree-search-input' v-model='searchword'
                placeholder="可输入关键词检索部门..." @change='search'
                :cssStyle='{width: "300px"}' style=" margin-left:40px"/>
      <v-tree ref='tree' :data='data' :multiple="false" :radio='true' @node-select="handleSelectionChange"
              :tpl='tpl' />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        data: [],
        selectedRow: null,
        searchword: '',

        showForm: false,

        form: {
          pid: null,
          deptIdsArray: [],
          name: '',
          status: null,
          phone: '',
        },
        rules: {
          deptIdsArray: [{ required: true, trigger: 'change', message: '请选择上级部门' }],
          name: [{required: true, trigger: 'blur', message: '请填写部门名称'}],
        },
        deptList: [],
        deptMapOfIdsArray: [],    // 用于级联组件显示部门时value值处理
      }
    },
    mounted() {
      this.query();
    },
    methods: {
      handleSelectionChange(row) {
        this.selectedRow = row;
      },
      search () {
        this.$refs.tree.searchNodes(this.searchword)
      },
      tpl(...args) {
        let {0: node, 1: parent, 2: index} = args
        let titleClass = node.selected? 'node-title node-selected' : 'node-title'

        if (node.searched) titleClass += ' node-searched'
        return <span>
                <span class = {titleClass} domPropsInnerHTML = { node.title }
                      onClick = {() => this.$refs.tree.nodeSelected(node)}></span>
               </span>
      },
      query() {
        this.loading = true;
        this.showForm = false;
        this.post('/client-dept/list', {
          }).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              this.deptList = [];
              this.deptMapOfIdsArray = [];
              if(resp.data.rows) {


                resp.data.rows.forEach(dept => {
                  this.deptList.push(dept);
                });

              

                this.Util.generateMapOfIdsArray(resp.data.rows, this.deptMapOfIdsArray);

                let depts = this._.cloneDeep(resp.data.rows);


                let handlerDepts = (dept) => {
                  dept.title = dept.label;
                  dept.expanded = true;
                  if(dept.children && dept.children.length > 0) {
                    dept.children.forEach(dept => {
                      handlerDepts(dept);
                    })
                  }
                };
                if(depts && depts.length > 0) {
                  depts.forEach(dept => {
                    handlerDepts(dept);
                  })
                }
                this.data = depts;
                

              }
            }
          }
        })
      },
      resetForm() {
        this.Util.reset(this.form);
        this.form.status = 2;
      },
      add() {
          this.title = '新增部门';
          this.resetForm();
          this.showForm = true;
      },
      edit() {
        if (this.selectedRow) {
          this.title = '修改部门';
          Object.assign(this.form, this.selectedRow);
          this.form.name = this.form.label;
          this.form.deptIdsArray = this.deptMapOfIdsArray[this.form.pid];
          this.showForm = true;
        } else {
          this.error(this.CONST.TIP.SELECT_ONE_FIRST);
        }
      },
      save() {
        let url = '';
        if(this.form.id) {
          url = '/client-dept/modify';
        } else {
          url = '/client-dept/add';
        }
        this.form.pid = this.form.deptIdsArray[this.form.deptIdsArray.length - 1];
        this.post(url, this.form).then(resp => {
          if(resp) {
            if (resp.data.success) {
              this.query();
              this.success(resp.data.msg);
              this.showForm = false;
            }
          }
        });
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/web/human_affairs/dept/list.vue